import { ApiClient } from "@equidefi/portals/clients";

class StripeClient extends ApiClient {
  async togglePaymentIntentType(investmentId, paymentIntentId, type) {
    const response = await this.post(`/v2/stripe/payment-intent/method/${investmentId}`, {
      type,
      payment_intent_id: paymentIntentId,
    });
    return response.data;
  }

  /**
   * @param {string} investmentId
   * @param {{ payment_method_type?: string }} [payload] The selected method, when
   *   the intent is created at confirm time and priced for that method.
   * @return {Promise<{ id: string, clientSecret: string, amount: number }>}
   */
  async createPaymentIntent(investmentId, payload = {}) {
    const response = await this.post(`/v2/stripe/payment-intent/${investmentId}`, payload);
    return response.data;
  }

  async createWirePaymentIntent(investmentId) {
    const response = await this.post(`/v2/stripe/payment-intent/wire/${investmentId}`);
    return response.data;
  }

  async acknowledgeWirePayment(investmentId, paymentIntentId) {
    const response = await this.post(`/v2/stripe/payment-intent/wire/${investmentId}/${paymentIntentId}/acknowledge`);
    return response.data;
  }

  async processPayment(investmentId, paymentId) {
    const response = await this.post(`/v2/stripe/process-payment/${investmentId}/${paymentId}`);
    return response.data;
  }

  async cancelUncompleted(investmentId) {
    const response = await this.post(`/v2/stripe/cancel-uncompleted/${investmentId}`);
    return response.data;
  }
}

export default StripeClient;
